import React from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardElementChangeEvent) => unknown;
	disabled?: boolean;
};

export function CardElementWrapper({ onChange, disabled }: Props): React.JSX.Element {
	return (
		<CardElement
			options={{
				hidePostalCode: true,
				disableLink: true,
				hideIcon: true,
				disabled,
				style: { base: { fontSize: '16px' } },
			}}
			onChange={onChange}
		/>
	);
}
